import React, { forwardRef } from 'react';
import styles from './Spinner.module.css';

export type SpinnerVariant = 'ring' | 'arc' | 'accent';
/** sm 13px, md 16px, lg 18px, xl 40px. */
export type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

export interface ISpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** arc draws only the top border; ring and accent are full rings with a coloured head. */
  variant?: SpinnerVariant;
  size?: SpinnerSize;
  label?: string;
}

const Spinner = forwardRef<HTMLSpanElement, ISpinnerProps>(
  ({ variant = 'ring', size = 'md', label = 'Loading', className, ...rest }, ref) => (
    <span
      ref={ref}
      role="status"
      aria-label={label}
      className={[styles.spinner, styles[variant], styles[size], className]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    />
  ),
);

Spinner.displayName = 'Spinner';

export default Spinner;
